import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientVaccineService = {
  getPatientVaccinesList(params){ return axiosRequest('GET', API_PATH.PATIENT_VACCINE.LIST(params)) },
  getPatientVaccine(data){ return axiosRequest('POST', API_PATH.PATIENT_VACCINE.INFO, data) },
  addPatientVaccine(data){ return axiosRequest('POST', API_PATH.PATIENT_VACCINE.ADD, data) },
  deletePatientVaccine(data){ return axiosRequest('POST', API_PATH.PATIENT_VACCINE.DELETE, data) },
}